export default [
  {
    path: '/data-report/pay',
    name: 'pay',
    component: () => import('@/views/data-report/pay'),
    meta: {
      title: '高考直通车-志愿服务'
    }
  },
]
